import React, { useEffect,  useMemo } from "react";
import styles from "../../css/communitySubsections.module.css";
import Answer from "../../../../public/images/question_answer_grey.svg";
import Answers from "../../../../public/images/answer.svg";
import { useDispatch, useSelector } from "react-redux";
import { PAGE_HASH_LOCATION } from "../../../app/utils/pages";
import { fetchDetailedAnswers } from "../../../shared/utils/sash-v2-api";
import { COMMUNITY_ACTION_TYPES } from "./communityReducer";

const CommunityMyAnswers = () => {
    const userId = useSelector((state) => state.userReducer.userId);
    const userAnswers = useSelector((state) => state.communityReducer.userAnswers);
    const dispatch = useDispatch();

    const successFunction = (res) => {
        dispatch({
            type: COMMUNITY_ACTION_TYPES.SET_USER_ANSWERS,
            payload: res.data,
        });
        dispatch({
            type: COMMUNITY_ACTION_TYPES.SET_USER_QUESTION_ANSWERS_COUNT,
            payload: res.question_count,
        });
    };

    const failureFunction = (error) => {
        console.error("Error fetching questions:", error);
    };

    useEffect(() => {
        if (userId) {
            fetchDetailedAnswers(successFunction, failureFunction , 7, 0);
        }
    }, []);

    const uniqueQuestions = useMemo(() => {
        if (!userAnswers) return [];
        const seenIds = new Set();
        return userAnswers.filter((item) => {
            const id = item.question?._id || item._id;
            if (seenIds.has(id)) {
                return false;
            }
            seenIds.add(id);
            return true;
        });
    }, [userAnswers]);

    const handleAnswersClick = (questionId) => {
        window.location.href = window.location.origin + PAGE_HASH_LOCATION.community + `/?id=${questionId}`;
    };

    const handleSeeAll = () => {
        window.location.href = window.location.origin + PAGE_HASH_LOCATION.community + `/myanswers`;
    }

    return (
        <div className={styles.subSectionsMain}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'0 15px'}}>
                <h4>My Answers</h4>
                {uniqueQuestions.length > 6 && <span onClick={handleSeeAll} className={styles.seeAll}>See All</span>}
            </div>
            <div>
            {uniqueQuestions.length === 0 || !userId ? (
                    <div className={styles.noQuestions}>
                        <img height={35} src={Answer} alt="No answers"/>
                        <p
                            style={{
                                fontSize: "13px",
                                textAlign: "center",
                                margin: "0",
                                padding: "0 5px",
                            }}
                        >
                            You haven't answered any questions yet
                        </p>
                    </div>
                ) :
                    (
                    <div style={{marginTop:'-9px'}}>
                    {uniqueQuestions.slice(0,6).map((question) => (
                        <div
                            onClick={()=>handleAnswersClick(question?.question?._id)}
                            key={question?.question?._id}
                            className={styles.questionItem}
                        >
                            <div className={styles.subSectionIcon} style={{cursor: "pointer"}}>
                                <img height={28} src={Answers} alt="answered question"/>
                            </div>
                            <div className={styles.questionDescription} style={{cursor: "pointer"}}>
                                <p style={{fontWeight: "1000"}}>
                                    {question?.question?.title || question?.title}
                                </p>
                                <p>{question?.question?.description || question?.description}</p>
                            </div>
                        </div>
                    ))}
                    </div>
                    )
                }
            </div>
        </div>
    );
};

export default CommunityMyAnswers;